/* 询价列表 */ /* 我的项目 */
<template>
  <lay-out>
    <div class="my-price">
      <div class="mem-page-title">询价列表</div>
      <div class="search-bar">
        <Input
          style="width:435px;"
          placeholder="请输入关键词搜索项目"
          v-model="filter.keyword"
          @on-search="searcHandle"
        >
          <i class="iconfont icon-sousuo1" slot="suffix"></i>
        </Input>
      </div>
      <div class="tabs">
        <Tabs
          :value="tabVal"
          class="search-bar-samll search-bar-samll-left"
          :animated="false"
          @on-click="changeTab"
        >
          <TabPane
            v-for="(item, index) in statusLists"
            :key="index"
            :label="index > 0 ? `${item.key}（${item.qtr}）` : `${item.key}`"
            :name="item.value.toString()"
          ></TabPane>
        </Tabs>
      </div>
      <div class="my-lists">
        <div v-if="lists && lists.length > 0">
          <inquiry-item :lists="lists" @undo="undoHandle"></inquiry-item>
        </div>
        <z-empty v-else txt="暂时还没有询价单哦！" :sl="false"></z-empty>
      </div>
      <div style="padding-bottom:30px;" class="pages" v-if="lists.length > 0">
        <z-page
          :total="total || 0"
          :elevator="true"
          :pageSize="filter.pageSize"
          v-model="filter.pageNum"
        ></z-page>
      </div>
    </div>
  </lay-out>
</template>

<script>
import axios from 'axios'
import LayOut from './layout'
import InquiryItem from '@/components/inquiry-item'
import { constructQueryParams } from '@/utils/queryParams.js'
let filter = {
  keyword: '',
  pageNum: 1,
  pageSize: 15,
  quoteStatus: 0,
  status: 0,
  valid: 1,
}
let statusLists = []
let tabVal = '0'

function changeTabStatus(thisObj) {
  filter.quoteStatus = Number(thisObj.quoteStatus)
  filter.status = Number(thisObj.status)
  filter.valid = Number(thisObj.valid)
  filter.pageNum = 1
}

/* 监听 query status的变化 */
function watchStatus(to) {
  return new Promise((reslove, reject) => {
    axios
      .get(`/designer_api/inquiry/status_num`)
      .then((res) => {
        statusLists = res
        let thisObj = statusLists.filter(
          (item) => item.value == Number(to.query.status)
        )[0]
        changeTabStatus(thisObj)
        reslove(true)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

/* 获得 list premise */
function getGlobalLists(to, next) {
  filter.keyword = ''
  axios
    .get(`/designer_api/inquiry${constructQueryParams(filter)}`, {
      globalLoading: true,
    })
    .then((res) => {
      next((vm) => {
        vm.tabVal = to.query.status || '0'
        vm.lists = res.list
        vm.total = res.total
      })
    })
}

export default {
  data() {
    return {
      filter: filter,
      tabVal: tabVal,
      constructQueryParams: constructQueryParams,
      lists: [],
      total: 0,
      statusLists: statusLists,
    }
  },
  components: {
    LayOut,
    InquiryItem,
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.status) {
      watchStatus(to).then((res) => {
        getGlobalLists(to, next)
      })
    } else {
      getGlobalLists(to, next)
    }
  },
  methods: {
    /* 搜索 */
    searcHandle(val) {
      this.filter.keyword = val
      this.getStatus()
      this.getLists()
    },

    getLists() {
      axios
        .get(`/designer_api/inquiry${this.constructQueryParams(this.filter)}`, {
          globalLoading: true,
        })
        .then((res) => {
          this.lists = res.list
          this.total = res.total
        })
    },

    getStatus() {
      axios
        .get(
          `/designer_api/inquiry/status_num${this.constructQueryParams(
            this.filter
          )}`
        )
        .then((res) => {
          this.statusLists = res
        })
    },

    /* 撤销 */
    undoHandle(id) {
      this.$Modal.confirm({
        loading: true,
        width: 450,
        content: `<div class="projectSwitchList"> <p><i class="iconfont icon-jinggao1 dialog-content-error"></i></p> <p>是否撤销本次询价？</p></div>`,
        onOk: () => {
          axios
            .put(`/designer_api/projects/${id}/cancel`)
            .then((res) => {
              this.getLists()
              this.$Message.success('撤销成功')
              this.$Modal.remove()
            })
            .catch((err) => {
              this.$Modal.remove()
            })
        },
      })
    },

    changeTab(val) {
      if (!val) return false
      let thisObj = this.statusLists.filter((item) => item.value == val)[0]
      changeTabStatus(thisObj)
      this.getLists()
    },
  },
  watch: {
    'filter.pageNum': function() {
      this.getLists()
    },
    $route: function() {
      this.filter.keyword = ''
      this.tabVal = this.$route.query.status
    },
  },
  created() {
    if (!this.$route.query.status) {
      this.getStatus()
    } else {
      this.tabVal = this.$route.query.status
    }
  },
}
</script>

<style lang="scss">
.my-price {
  background: #fff;
  .search-bar {
    padding: 30px;
  }
  .tabs {
    padding: 0 30px;
  }
  .my-lists {
    padding: 30px;
    padding-top: 10px;
  }
}

.projectSwitchList {
  p {
    color: #313131;
    text-align: center;
    margin-bottom: 10px;
    i {
      color: #e56a69;
      font-size: 50px;
    }
  }
}
</style>
